// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3jJ2n","footer":"styles_footer__1LipS"};